import { useState } from 'react';
import { basicFormValidationHandler, formatText } from '../../../utils.js';
import { isEmpty } from 'lodash';
import withTranslations from '../../../utils/HighOrderComponent';
import { minPasswordLength } from '../../../constants/globals';
import FormWrapper from '../../Reusable/FormWrapper/FormWrapper.js';
import PasswordChangeFields from './PasswordChangeFields.js';

const PasswordChangeForm = (props) => {
  const { t, submitHandler, submitRef } = props || {},
    { Errors } = t || {};

  const [state, setState] = useState({
    newPassword: null,
    confirmNewPassword: null,
  });
  const [errors, setErrors] = useState({});

  const { newPassword, confirmNewPassword } = state;

  const onChangeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (
      ((name === 'newPassword' && value === confirmNewPassword) ||
        (name === 'confirmNewPassword' && value === newPassword)) &&
      errors.passwordAndConfirmPasswordMatch
    ) {
      setErrors((prevState) => {
        delete prevState['passwordAndConfirmPasswordMatch'];
        return prevState;
      });
    }
  };

  const clientValidationHandler = () => {
    const errorsObject = basicFormValidationHandler(
      { newPassword, confirmNewPassword },
      Errors
    );
    if (newPassword) {
      if (newPassword?.length < minPasswordLength) {
        errorsObject['newPassword'] = formatText(
          Errors.passwordLength,
          minPasswordLength
        );
      }
      if (
        confirmNewPassword &&
        newPassword?.trim() !== confirmNewPassword?.trim()
      ) {
        errorsObject['passwordAndConfirmPasswordMatch'] =
          Errors.passwordAndConfirmPasswordMatch;
      }
    }
    setErrors(errorsObject);
    return !isEmpty(errorsObject);
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (clientValidationHandler()) return;
    const userPasswordChangingDTO = {
      newPassword,
      confirmNewPassword,
    };
    submitHandler(userPasswordChangingDTO);
  };

  return (
    <FormWrapper
      submitRef={submitRef}
      noValidate={true}
      onSubmit={onSubmitHandler}
    >
      <PasswordChangeFields
        newPassword={newPassword}
        confirmNewPassword={confirmNewPassword}
        t={t}
        errors={errors}
        setErrors={setErrors}
        onChangeHandler={onChangeHandler}
      />
    </FormWrapper>
  );
};

export default withTranslations(PasswordChangeForm, 'PasswordChangeForm');
